import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import Container = Phaser.GameObjects.Container;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {StringUtils} from "@/utils/string-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import {ForceUpdateInfo} from "@/store/force/types";
import {ForceBasePanel} from "@/scenes.ui/force-base-panel";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";
import {WarriorClass} from "@/store/level/types";

export class ForceMaxLevelPanel extends ForceBasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ui: ForceUpdateInfo, slotX: number, slotY: number, container: Container) {
        super(scene, canvas, slotX, slotY, container);

        let blackZone = SpriteUtils.addSprite(this.scene, 0, -150+2, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 1.7);
        let blackZone3 = SpriteUtils.addSprite(this.scene, 0, 50, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_ZONE, 0.95, 3.60);
        blackZone3.setOrigin(0.5, 0);

        let hideRank = ui.currentLevel == 0 || (ui.currentLevel == 1 && !ui.canUpgrade);

        let forceName = PlayerStore.getPlayer().lang == Lang.RU ?
            StringUtils.capitalizeFirstLetter(Tr('force')) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(ui.warriorClass)) :
            StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(ui.warriorClass)) + ' ' + StringUtils.capitalizeFirstLetter(Tr('force'));

        const title = TextUtils.addTextByFamily(this.scene, forceName, 0, -278, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let levelText = TextUtils.addTextByFamily(scene, hideRank? forceName : Tr('rang') + " " + String(ui.currentLevel) + ' (' + Tr('maks.dot') + ')',
            0, -223, '#ffedc6', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0-4, -150 + 6, Keys.ATLAS_UI, Keys.UI_BADGE_LINER, 1.1);
        let item = SpriteUtils.addSprite(this.scene, 0, -150,
            CreatureUtils.getForceAtlasLarge(ui.warriorClass), CreatureUtils.getLargeForceIcon(ui.warriorClass, true), 0.8);

        const fromRankBg = SpriteUtils.addImage(this.scene,
             33, -150 +33, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_INDICATOR_BG, 1.1, 1.1).setOrigin(0.5, 0.5);
        let fromRankNumber = TextUtils.addTextByFamily(scene, ui.currentLevel.toString(),
             34, -150 + 35,'#daba6f', 15, 'bold', 450, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);
        fromRankBg.setVisible(!hideRank);
        fromRankNumber.setVisible(!hideRank);

        let forceInfoLabel = TextUtils.addTextAdvanced(scene, ui.description, 0, -22,
            '#d7d7d7', 13, 'normal', 300, 'center', 2, Fonts.ARIAL_MT);
        forceInfoLabel.setOrigin(0.5, 0.5);

        let maxLevelLabel = TextUtils.addTextAdvanced(scene, ui.currentLevel == 0? Tr('dar.poka.ne.dostupen') : Tr('sila.na.maksimalnom.urovne'), 0, 93,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let okButton = new SquareButton(this.scene, 0, 192, 0,
            Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('zakrit'), false);

        okButton.setScale(0.9, 0.9)

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                this.close();
            }
        });

        this.add([blackZone, blackZone3, title, levelText, light, item, maxLevelLabel, fromRankBg, fromRankNumber,
             okButton, forceInfoLabel, okButton]);
    }
}
